// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OptionMenu__container___3yYno{flex-direction:row}.OptionMenu__container___3yYno,.OptionMenu__item___3_F8X{display:flex;justify-content:center}.OptionMenu__item___3_F8X{align-items:center;width:250px;height:120px;margin:10px;border:2px solid #eae9e3;border-radius:8px;font-size:20px;cursor:pointer}.OptionMenu__isSelected___1gi9D{border-color:#2d50e6;box-shadow:0 0 0 4px #d6e3fd}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "OptionMenu__container___3yYno",
	"item": "OptionMenu__item___3_F8X",
	"isSelected": "OptionMenu__isSelected___1gi9D"
};
module.exports = ___CSS_LOADER_EXPORT___;
